import React from 'react'
import { TableCell } from './TableCell'
import { ColumnTable } from './types/TableTypes'

type TableBodyProps = {
  columns: ColumnTable[]
  data: any[]
}

export const TableBody = ({ columns, data }: TableBodyProps) => {
  return (
    <tbody>
      {data.map((res, i) => {
        return (
          <tr key={`row_${i}`}>
            {columns.map((col, j) => {
              const options = {
                row: res,
                value: res[col.columnName],
                index: i,
                data,
                column: col
              }

              const className =
                typeof col.tdClassName === 'function'
                  ? col.tdClassName(options)
                  : col.tdClassName

              const tdProps =
                typeof col.tdProps === 'function'
                  ? col.tdProps(options)
                  : col.tdProps

              return (
                <TableCell
                  className={className}
                  key={`body_${i}_${j}`}
                  bold={col.bold}
                  width={col.width}
                  {...tdProps}
                >
                  {col.cellFormat
                    ? col.cellFormat(options)
                    : res[col.columnName]}
                </TableCell>
              )
            })}
          </tr>
        )
      })}
    </tbody>
  )
}
